import React from 'react'
import { HiOutlineTrash, HiOutlinePencilAlt } from "react-icons/hi";
import { Table, Card, Group, ActionIcon, Tooltip, Badge, Text, Box } from '@mantine/core'

const UsersTable = ({ items, onOpen, remove }) =>
{
  return (
    <Card shadow="md" p={0} radius="lg" withBorder mx="md" w="100%" className="overflow-hidden">
      <Table.ScrollContainer minWidth={ 600 }>
        <Table verticalSpacing="md" highlightOnHover>
          <Table.Thead bg="gray.0">
            <Table.Tr>
              <Table.Th px="xl" py="md"><Text size="xs" fw={800} c="dimmed" className="tracking-widest uppercase">Credenciales</Text></Table.Th>
              <Table.Th><Text size="xs" fw={800} c="dimmed" className="tracking-widest uppercase">Nombre Completo</Text></Table.Th>
              <Table.Th><Text size="xs" fw={800} c="dimmed" className="tracking-widest uppercase">Estado</Text></Table.Th>
              <Table.Th><Text size="xs" fw={800} c="dimmed" className="tracking-widest uppercase">Rol de Acceso</Text></Table.Th>
              <Table.Th></Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            { items && items.map((item) => (
              <Table.Tr 
                key={ item._id }
                className="hover:bg-slate-50 transition-colors duration-200"
                style={{ borderLeft: '4px solid transparent' }}
                onMouseEnter={(e) => e.currentTarget.style.borderLeft = '4px solid var(--mantine-color-yellow-filled)'}
                onMouseLeave={(e) => e.currentTarget.style.borderLeft = '4px solid transparent'}
              >
                <Table.Td px="xl">
                  <Box>
                    <Text fw={700} size="sm">{ item.username }</Text>
                    <Text size="xs" c="dimmed">{ item?.email || 'N/A' }</Text>
                  </Box>
                </Table.Td>
                
                <Table.Td>
                  <Text size="sm" fw={600}>{ item.name }</Text>
                </Table.Td>

                <Table.Td>
                  { item?.status ? 
                    <Badge color="green" variant="light" radius="sm">Activo</Badge> : 
                    <Badge color="red" variant="light" radius="sm">Inactivo</Badge> 
                  }
                </Table.Td>

                <Table.Td>
                  <Badge 
                    variant="dot" 
                    color={item?.role === 'SUPER_ADMIN' ? 'yellow' : 'gray'} 
                    size="md"
                  >
                    { item?.role }
                  </Badge>
                </Table.Td>

                <Table.Td px="xl">
                  <Group gap="xs" justify="flex-end">
                    <Tooltip label='Editar usuario' fontSize='xs' radius="md" withArrow>
                      <ActionIcon variant="light" size="lg" onClick={ () => onOpen(item) }>
                        <HiOutlinePencilAlt size={18} />
                      </ActionIcon>
                    </Tooltip>
                    
                    <Tooltip label='Borrar usuario' fontSize='xs' radius="md" withArrow>
                      <ActionIcon variant="subtle" color="red" size="lg" onClick={ () => remove({ _id: item._id }) }>
                        <HiOutlineTrash size={18} />
                      </ActionIcon>
                    </Tooltip>
                  </Group>
                </Table.Td>
              </Table.Tr>
            )) }
          </Table.Tbody>
        </Table>
      </Table.ScrollContainer>
    </Card>
  )
}

export default UsersTable
